var angular = require('angular');
var _module = angular.module('listreports.sdr', []);
var _       = require('lodash');

_module.service('$sdr', [
    '$http', '$q',
    function($http, $q) {
        var API_URL  = "https://www.listreports.com";

        this.fetchSdrInfo = function(userId) {
            var endPoint = API_URL + '/v1/users/' + userId + '/sdr-Info';
            return $q( function(resolve, reject) {
                $http.get(endPoint)
                    .then(function(response) {
                        resolve(response.data.data);
                    })
                    .catch(function(err) {
                        reject(err);
                    });
            });
        };

        this.parseSrdFields = function(sdrObj) {
            var viewSdrObj = _.cloneDeep(sdrObj);
            if(viewSdrObj.phone) {
                var phone = viewSdrObj.phone;
                phone = phone.slice(0, 3) + '-' + phone.slice(3, 6) + '-' + phone.slice(-4);
                viewSdrObj.phone = phone;
            }
            if(!viewSdrObj.headshot) {
                viewSdrObj.headshot = '../../images/headshot.png';
            }
            return viewSdrObj;
        };
    }
]);